<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "LineEchart3",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "折线图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,255,255,.0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,90,173)",
                  },
                ],
              },
            },
          },
        },
        grid: {
          top: 35,
          left: "3%",
          right: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            name: this.xAxisName,
            nameTextStyle: {
              color: "#c0c3cd",
              fontSize: 12,
            },
            data: this.chartData.days,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
                width: 3,
              },
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 12,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.yAxisName,
            nameTextStyle: {
              color: "#c0c3cd",

              fontSize: 12,
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 12,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
                width: 3,
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgb(37,82,121)",
                width: 3,
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            data: this.chartData.data,
            symbol: "circle",
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: "rgba(3, 162, 228, 1)",
                width: 3,
              },
            },
            itemStyle: {
              color: "rgba(127, 216, 252, 1)",
              shadowBlur: 5,
              shadowColor: "#fff",
            },
            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(42, 193, 255, 0.8)",
                    },
                    {
                      offset: 1,
                      color: "rgba(42, 193, 255, 0)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(42, 193, 255, 0.5)", //阴影颜色
                shadowBlur: 20, //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
              },
            },
          },
        ],
      });
    },
  },
};
</script>
